import { render, staticRenderFns } from "./EditXLetterModal.vue?vue&type=template&id=6227531a&"
import script from "./EditXLetterModal.vue?vue&type=script&lang=js&"
export * from "./EditXLetterModal.vue?vue&type=script&lang=js&"
import style0 from "./EditXLetterModal.vue?vue&type=style&index=0&id=6227531a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports